import { SL_ID_PREFIX, SlIdContext } from './../../../model/directives/sl-id-context';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { FeatureInfo } from '../../results-view/results-view.component';
import { AttributeInfo, AttributeRequirement, AnyHandler } from 'src/app/types/@types/sl-v-types';
import { CastingFormatType } from '../../att-casting-view/formats/casting-formats-sel/casting-formats-sel.component';
import { AttStorageType } from 'src/app/model/api-services/attributes.service';
import { Validator, ValidationResults } from 'src/app/model/validator';
import { SLLayer, LayerGeomtypes } from 'src/app/model/sl-layer';
import { SLMap } from 'src/app/model/sl-map';
import { LayerSelectComponent } from '../../layer-select/layer-select.component';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { VertexToolsComponent } from '../vertex-tools/vertex-tools.component';
import { PointFeature } from 'src/app/model/drawing/PointFeature';
import { PolyFeature } from 'src/app/model/drawing/PolyFeature';
import { LineFeature } from 'src/app/model/drawing/LineFeature';
import { IFeature, Feature } from 'src/app/model/drawing/Feature';
import { FeatureService } from 'src/app/model/api-services/feature.service';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { ActionHandlerService } from 'src/app/services/action-handler.service';
import { InfoAction } from 'src/app/model/map-actions/info-action';

@Component({
  selector: 'app-att-editor',
  templateUrl: './att-editor.component.html',
  styleUrls: ['./att-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  providers: [
    SlIdContext,
    {
      provide: SL_ID_PREFIX,
      useValue: 'att-editor'
    }
  ],
})
export class AttEditorComponent implements OnInit {

  public validator: Validator = new Validator([]);
  @Output() validatorChange = new EventEmitter<Validator>();
  public feature: FeatureInfo = { count: 0, feature: {}, index: -1, layer: null };
  public get featureLayer(): SLLayer | undefined {
    if (!this.feature) return undefined;
    if (!this.feature.layer) return undefined;
    return this.feature.layer;
  }
  public layer: SLLayer = null;
  public handlingLayer = false;
  public dataReady = false;
  public attributes: Array<AttributeInfo>;
  private subscriptions: SubScriptionMgr = new SubScriptionMgr();
  @Input()
  public slMap: SLMap;
  @Input()
  public layerSel: LayerSelectComponent;
  private _vertexTools: VertexToolsComponent;
  public vertexToolsReady = false;
  @Input()
  public SubmssionHandler: AnyHandler = () => { };
  @Input()
  public DeleteHandler: AnyHandler = () => { };

  @Input()
  public set vertexTools(tools: VertexToolsComponent) {
    if (this._vertexTools) {
      return;
    }
    this._vertexTools = tools;
    this.subscriptions.Subscribe(this._vertexTools.geometryChange, () => {
      const selection = this._vertexTools.selectedGeometry;

      let hadChange = false;
      if (this.layer && this.layer.geom && this.layer.geom === 'point') {
        const hasPointSelection = !(!selection || (selection.type !== 'point'));
        const hasSpatialCoord = (!!hasPointSelection && !!selection.coord && !!selection.coord.spatial);
        this.geomReady = false;
        const geomParts = {}
        if (this.attributes) {
          for (const att of this.attributes) {
            if (!(!!att.casting && !!att.casting.entry && !!att.casting.entry.geoLocPart)) {
              continue;
            }
            let part: string = att.casting.entry.geoLocPart;
            switch (part) {
              case 'lattitude':
                part = 'lat';
                geomParts[part] = att;
                break;
              case 'longitude':
                part = 'lng'
                geomParts[part] = att;
                break;
              case 'accuracy':
                part = 'accuracy'
                geomParts[part] = att;
                break;

            }

            if (!hasPointSelection && !hasSpatialCoord) {
              this.validator.SetValue(att.name, null);
            } else {
              this.validator.SetValue(att.name, selection.coord.spatial[part]);
            }
            this.validatorChange.emit(this.validator);
            this.cdr.markForCheck();
            this.cdr.detectChanges();
            // hadChange = true;
          }
          const original = this.validator.GetOriginal();
          if (geomParts['lat'] && geomParts['lng'] && geomParts['accuracy']) {
            const latAttName = geomParts['lat']?.name;
            const lngAttName = geomParts['lng']?.name;
            const accAttName = geomParts['accuracy']?.name;
            let wasOrig = false;
            if (latAttName && this.validator.GetIsGeoriginal(latAttName)) {
              if (lngAttName && this.validator.GetIsGeoriginal(lngAttName)) {
                wasOrig = true;
                this.validator.SetValue(accAttName, this.validator.GetOriginalValue(accAttName))
              }
            }
            // if(!wasOrig) this.validator.SetValue(accAttName,0);
          }
        }
      }
      if (this.validator.attributes.length > 0 && this.slMap && this.slMap.component && this.slMap.component.drawPane) {
        const selectedFeature: Feature = this.slMap.component.drawPane.GetSelectedFeature();
        if (!!selectedFeature) {
          this.validator.SetValue('geojson_geom', selectedFeature.ToGeoJSONGeom());
        }
      }
      this.geomReady = true;

      /*if (hadChange === true) {
        this.dataReady = false;
        this.cdr.detectChanges();
        this.dataReady = true;

      }*/
      this.cdr.detectChanges();
    });
    this.vertexToolsReady = true;

    this.cdr.detectChanges();
  }
  public get featureID(): string {
    if (!this.feature) 'None'
    if (this.feature?.feature?.gid) return '' + this.feature?.feature?.gid;
    return 'New Feature'
  }
  public get readyToDisplay(): boolean {
    return this.dataReady && this.vertexToolsReady;
  }

  private _geomReady: boolean = false;
  get geomReady(): boolean {
    return this._geomReady;
  }
  private set geomReady(_val: boolean) {
    this._geomReady = _val;
    this.Refresh(true);

  }
  constructor(private cdr: ChangeDetectorRef, private featureSvc: FeatureService, private messager: ModalMessagerService, private actions: ActionHandlerService) {

  }

  ngOnInit(): void {
    this.subscriptions.Subscribe(this.layerSel.layerChange, (layer: SLLayer) => {
      this.handlingLayer = true;
      this.HandleLayer(layer);
    });
  };

  HandleLayer(layer: SLLayer) {
    if (layer && this.layer && layer.id && this.layer.id && this.layer.id === layer.id) {
      this.handlingLayer = false;
      return;
    }
    this.layer = layer;
    this.slMap.component.SetDigitizerLayer(this.layer);
    if (!!layer) {
      const feature: FeatureInfo = {
        count: 1,
        feature: this.layer.GetEmptyRecord(),
        index: 0,
        layer: this.layer
      }
      this.ShowFeature(feature);
    } else {
      this.Reset();
    }
    this.handlingLayer = false;

  }
  SubmitForm(event?: _Event, loadHandler?: AnyHandler): boolean {
    if (event) {
      event.preventDefault();
    }
    const validation: ValidationResults = this.validator.Validate();
    const validationData = validation.data;
    const featureId = validationData['gid'] ? validationData['gid'] : null;
    if (validation.isValid === false) {
      this.cdr.detectChanges();
      return false;
    }

    this.featureSvc.UpdateFeature(this.layer, featureId, validationData).then((result) => {
      if (this.slMap.component.drawPane.hasVertices) {
        if (result?.record?.gid) {
          this.slMap.component.drawPane.SaveFeature(false, result.record.gid);
        }
      }
      if (result.status === 'ok') {
        this.layer.Touch();
        this.layer.Render();
        if (!!loadHandler) {
          loadHandler(result);
        }
        this.messager.Progress('Uploading Complete', true, 1, 'Feature Submission');

        if (result && result.record) {
          const featureInfo: FeatureInfo = {
            count: 1,
            feature: result.record,
            index: 0,
            layer: this.layer
          }
          this.SubmssionHandler(featureInfo);
          this.actions.HandleAction('info/refresh-results-layer', this.layer, result.record);


        }
        InfoAction.FeatureEdit(this.slMap.component, result);


        // this.NewFeature(this.layer);
      }

    });
    this.messager.Progress('Uploading content', false, .5, 'Feature Submission');

  }

  NewFeature(layer?: SLLayer, feature?: FeatureInfo) {

    let changed = false;
    if (!!layer) {
      if (!(!!this.layer && !!layer && (this.layer.id === layer.id))) {
        changed = this.layerSel.SetLayer(layer);

        if (changed === true) {
          this.HandleLayer(layer);
          return;
        }
      }
    } else if (this.layer) {

      layer = this.layer;
    }
    this.dataReady = false;
    this.cdr.detectChanges();

    if (layer) {
      // this.layerSel.SetLayer(layer);
      this.validator.SetAttributes(layer.layerAttributes);
      if (feature) {
        this.ShowFeature(feature);
      } else {
        this.ShowFeature(layer.GetEmptyRecord());
      }
      this.dataReady = true;
      this.cdr.detectChanges();
      return;
    }

    this.dataReady = false;
    this.cdr.detectChanges();

  }
  ShowFeature(feature: FeatureInfo) {// , validator: Validator) {
    this.feature = undefined;
    if (feature === undefined) {
      return;
    }
    if (!feature.layer) {
      return;
    }
    this.dataReady = false;
    this.cdr.detectChanges();
    this.feature = feature;
    this.validator.SetAttributes(this.feature.layer.layerAttributes);
    this.validator.SetData(feature.feature);
    this.attributes = this.validator.attributes;
    window.requestAnimationFrame(() => {
      if (this.layer !== undefined)
        this.dataReady = true;
      this.cdr?.detectChanges();
    });

    /* if (!this.validator) {
      this.subscriptions.Subscribe(
        this.validator.validityChange, (changes: ValidationResults) => {
          if (changes.isValid === true) {
            this.currentFeature = this.validator.GetData();
            this.SaveChanges();
          }
        });
      this.subscriptions.Subscribe(
        this.validator.availMapChange, (changes: AvailabilityDict) => {
          changes = null;
          // ToDO: Handle availMapChange(changes)
        });
    } else {
      this.validator.SetAttributes(this.layer.layerAttributes);
    }
    */
  }
  IsInput(attribute: AttributeInfo, type: CastingFormatType | AttributeRequirement): boolean {
    if (Number(attribute.visible) === 0) {
      return false;
    }
    if (attribute.casting && attribute.casting.entry && attribute.casting.entry.type) {
      if (type === 'number-general') {
        if (attribute.casting.entry.type === 'number-general') {
        }
      }
    }



    return this.WhichInput(attribute) === type;
  }
  WhichInput(attribute: AttributeInfo): CastingFormatType | AttributeRequirement {

    if (!!attribute.casting) {
      if (!!attribute.casting.entry) {

        return attribute.casting.entry.type;
      }
    }
    const attSrc = attribute.type ?? attribute.requires;
    switch (attSrc as AttStorageType) {
      case 'text':
      case 'string':
        if (['url', 'cg_url'].indexOf(attribute.requires) > -1) {
          return 'url';
        }
        return 'text';
      case 'boolean':
        return 'boolean';
      case 'date':
        return 'date';
      case 'time':
        return 'time';
      case 'float':
      case 'int':
      case 'integer':
        return 'number-general'
      case 'cg_url':
      case 'url':
        return 'link';
    }
  }
  Validate() {
    this.validator.Validate();
  }
  GetData() {
    return this.validator.GetData();
  }

  Reset(gidOnly: boolean = false) {
    this.dataReady = false;
    this.cdr.detectChanges();
    let feature = undefined;
    feature = this.feature;
    if (!this.layer) return;
    if (gidOnly) {
      if (!!this.feature.feature['gid']) {
        delete feature.feature['gid'];
      }
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    } else {
      feature = {
        count: 1,
        feature: this.layer.GetEmptyRecord(),
        layer: this.layer,
        index: 0
      }
    }

    this.ShowFeature(feature);
  }

  Redraw() {
    this.dataReady = false;
    this.cdr.detectChanges();
    setTimeout(() => {
      if (this.layer === undefined) return;
      this.dataReady = true;
      this.cdr.detectChanges();
    }, 20);
  }
  Refresh(cdrOnly: boolean = false) {
    if (cdrOnly === true) {
      this.cdr.detectChanges();
      return;
    }
    if (this.layer) {
      const feature: FeatureInfo = {
        count: 1,
        feature: this.validator.GetOriginal(),
        layer: this.layer,
        index: 0
      } // this.GetData();
      this.Reset();
      this.ShowFeature(feature);
    }
  }
  Clear() {
    this.attributes = [];
    this.validator.SetAttributes([]);
    this.validator.SetData({});
    this.layer = undefined;
    this.feature = { count: 0, feature: {}, index: -1, layer: undefined }
    this.dataReady = false;
    this.Refresh(true);
    // this.Refresh(true);
  }
  DeleteRecord(featureId) {
    this.messager.Confirm('Deleting a feature cannot be undone. If you want to delete the current feature press ok to continue, otherwise click cancel to continue without deleting.', () => {
      this.featureSvc.DeleteFeature(this.layer, featureId).then(() => {
        this.DeleteHandler(this.feature);
        this.Reset();
        this.layer.Render();
      });
    }, () => { }, 'Delete current feature?');
  }

}
